import { axiosInstanceWebsite } from "../instance";

export interface NotificationItem {
  id: number;
  category: string;
  type: string;
  severity: "INFO" | "WARNING" | "CRITICAL";
  status: "OPEN" | "ACKNOWLEDGED" | "RESOLVED";
  title: string;
  body?: string | null;
  actionType?: string | null;
  actionTarget?: string | null;
  orderId?: number | null;
  websiteId?: string | null;
  occurrences: number;
  read: boolean;
  createdAt: string;
  lastSeenAt: string;
}

export interface NotificationListResponse {
  items: NotificationItem[];
  unreadCount: number;
}

export const fetchNotifications = (params?: { status?: string; category?: string }) =>
  axiosInstanceWebsite
    .get<NotificationListResponse>("/notifications", { params })
    .then((r) => r.data);

export const fetchUnreadCount = () =>
  axiosInstanceWebsite.get<{ count: number }>("/notifications/unread-count").then((r) => r.data);

export const markNotificationRead = (id: number) =>
  axiosInstanceWebsite.post(`/notifications/${id}/read`);

export const markAllNotificationsRead = () =>
  axiosInstanceWebsite.post(`/notifications/read-all`);

export const dismissNotification = (id: number) =>
  axiosInstanceWebsite.post(`/notifications/${id}/dismiss`);
